import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted brand fonts (loaded once, at the application entry point).
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import '@fontsource/lexend/300.css';
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';
import '@fontsource/lexend/600.css';

import App from './app/App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element "#root" was not found in the document.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
